// AnnualVolumeQuestion.jsx
import React from "react";
import { Box } from "@mui/material";
import PerlLabelMedium from "../../components/PerlLabelMedium";
import PerlChip from "../../components/PerlChip";

/**
 * AnnualVolumeQuestion - Shared question component
 * Used by: F&B, Mechanical, Electronics, Packaging
 *
 * Chip-based selection for annual volume range
 */
export default function AnnualVolumeQuestion({
  value,
  onChange,
  onAutoAdvance, // Auto-advance handler from ChatInterface
  autoAdvanceOnSelect = false, // Enable auto-advance on selection
}) {
  const options = [
    { value: "Low (< 100,000 units)", label: "Low (< 100,000 units)" },
    { value: "Medium (100,000 - 500,000 units)", label: "Medium (100,000 - 500,000 units)" },
    { value: "High (> 500,000 units)", label: "High (> 500,000 units)" },
  ];

  return (
    <>
      <PerlLabelMedium sx={{ mb: 2, display: "block" }}>
        Select Annual Volume Range:
      </PerlLabelMedium>
      <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
        {options.map((option) => (
          <PerlChip
            key={option.value}
            label={option.label}
            selected={value === option.value}
            onClick={() => {
              onChange(option.value);
              if (autoAdvanceOnSelect && onAutoAdvance) {
                onAutoAdvance();
              }
            }}
          />
        ))}
      </Box>
    </>
  );
}
